import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/hero.css";

const Hero = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false); // ✅ Modal state

  const handleDispatchClick = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dispatch-history"); // ✅ Logged in
    } else {
      setShowAuthModal(true); // 🔥 Show modal if not logged in
    }
  };

  return (
    <div className="hero section-container">
      <div className="hero-container">
        {/* ✅ Heading & Subtext */}
        <div className="hero-heading-frame">
          <h1 className="hero-title">
            Fast and Secure <span className="highlight">Document</span> <br />
            <span className="highlight">Dispatch</span> Services.
          </h1>
          <p className="hero-subtext">
            Dispatch your documents anywhere with ease and confidence.
          </p>
        </div>

        {/* ✅ Button & Arrow */}
        <div className="hero-action">
          <img
            src="/arrow-icon.svg"
            alt="Arrow Icon"
            className="hero-arrow-icon"
          />
          <button className="dispatch-btn" onClick={handleDispatchClick}>
            Dispatch Now
          </button>
        </div>
      </div>

      {/* ✅ Auth Modal */}
      {showAuthModal && (
        <div className="auth-modal-overlay">
          <div className="auth-modal">
            <h3>Login Required</h3>
            <p>
              Hey there! You’ll need to sign in or create an account to dispatch your documents.
            </p>
            <div className="auth-modal-buttons">
              <button onClick={() => navigate("/login")}>Login</button>
              <button onClick={() => navigate("/signup")}>Sign Up</button>
              <button
                onClick={() => setShowAuthModal(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;
